<template>
    <div class="cr:relative cr:inline-flex cr:items-center cr:justify-center">
        <input
            class="cr:h-5 cr:w-5 cr:shrink-0 cr:rounded-full cr:appearance-none cr:border cr:cursor-pointer"
            type="checkbox"
            v-model="model"
            :value="value"
            :disabled="disabled"
            :class="originClasses"
        />
        <svg class="cr:absolute cr:w-3 cr:pointer-events-none" viewBox="0 0 41 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M40.1097 0.864402C41.2852 2.02831 41.2983 3.92853 40.139 5.10867L14.1643 31.5478C13.3805 32.3456 12.0948 32.3456 11.311 31.5478L0.861051 20.911C-0.298347 19.7309 -0.285248 17.8306 0.890309 16.6667C2.06587 15.5028 3.95872 15.516 5.11812 16.6961L11.311 22.9997C12.0948 23.7975 13.3805 23.7975 14.1643 22.9997L35.8819 0.893774C37.0413 -0.286358 38.9341 -0.299508 40.1097 0.864402Z"
                  fill="white"/>
        </svg>
    </div>

</template>

<script setup lang="ts">
import {computed} from "vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import {ORIGINS} from "@/services/ConstantSerice.ts";

const registrationStore = useRegistrationStore();
const props = defineProps({
    modelValue: {
        type: [Array, Boolean]
    },
    value: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(["update:modelValue"]);

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    },
});

const originClasses = computed(() => {
    switch (registrationStore.registrationOrigin?.toLocaleLowerCase()) {
        case ORIGINS.BE:
            return 'cr:border-[var(--be-primary)] cr:checked:bg-[var(--be-primary)] cr:hover:bg-[var(--be-hover)] cr:checked:hover:bg-[var(--be-primary)]';
        case ORIGINS.KE:
            return 'cr:border-[var(--ke-primary)] cr:checked:bg-[var(--ke-primary)] cr:hover:bg-[var(--ke-hover)] cr:checked:hover:bg-[var(--ke-primary)]';
        case ORIGINS.FIXR:
            return 'cr:border-[var(--fixr-primary)] cr:checked:bg-[var(--fixr-primary)] cr:hover:bg-[var(--fixr-hover)] cr:checked:hover:bg-[var(--fixr-primary)]';
        case ORIGINS.SR:
            return 'cr:border-[var(--sr-primary)] cr:checked:bg-[var(--sr-primary)] cr:hover:bg-[var(--sr-hover)] cr:checked:hover:bg-[var(--sr-primary)]';
        case ORIGINS.RC:
            return 'cr:border-[var(--rc-primary)] cr:checked:bg-[var(--rc-primary)] cr:hover:bg-[var(--rc-hover)] cr:checked:hover:bg-[var(--rc-primary)]';
        case ORIGINS.HM:
            return 'cr:border-[var(--hm-primary)] cr:checked:bg-[var(--hm-primary)] cr:hover:bg-[var(--hm-hover)] cr:checked:hover:bg-[var(--hm-primary)]';
        default:
            return 'cr:border-[var(--default-primary)] cr:checked:bg-[var(--default-primary)] cr:hover:bg-[var(--default-hover)] cr:checked:hover:bg-[var(--default-primary)]';
    }
});

</script>
